import { useEffect, useRef } from 'react';

/**
 * The row and header checkboxes for a bulk-selectable table.
 *
 * Small, but worth sharing for one reason: the header checkbox must render the
 * INDETERMINATE state when only some rows are ticked. That is a DOM property,
 * not an attribute, so React cannot set it from JSX and every page that
 * hand-rolls this ends up showing a plain unticked box for "some selected" --
 * which reads as "nothing is selected" while an action bar says six are.
 */
export function BulkSelectAllCheckbox({
  checked,
  indeterminate,
  onChange,
  label = 'Select all rows on this page',
}: {
  checked: boolean;
  indeterminate: boolean;
  onChange: () => void;
  label?: string;
}) {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate && !checked;
  }, [indeterminate, checked]);

  return (
    <input
      ref={ref}
      type="checkbox"
      aria-label={label}
      checked={checked}
      onChange={onChange}
      className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700"
    />
  );
}

export function BulkSelectCheckbox({
  checked,
  onChange,
  label,
}: {
  checked: boolean;
  onChange: () => void;
  label: string;
}) {
  return (
    <input
      type="checkbox"
      aria-label={label}
      checked={checked}
      onChange={onChange}
      className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700"
    />
  );
}
